module.exports = __webpack_public_path__ + "media/images/menu/charon-f458ff792c5d6849acfe53dcbdc74343.jpg";